import { authenticatedPatch } from '../../../../../../api/request';

export default async function updateBasicProfile(idDoctorUser, basicProfile, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando su información de perfil.');
    const url = `/doctor-profile-management/update-main-profile/${idDoctorUser}`;
    return await authenticatedPatch(url, onFail, basicProfile);
}
